exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".orientation-vertical[data-v-724b4431]{display:flex;flex-direction:column}.orientation-horizontal[data-v-724b4431]{display:flex;flex-direction:row}\n", ""]);

